import {Link} from 'react-router-dom'
import { PropTypes } from 'prop-types'
import {criticalLevel, taskStatu} from 'utils/Constants'
import moment from 'moment'
const Task = ({task}) => {
    
  return (
        <Link to={`${task.id}`}  className="tasks-list-item">
        <div className={`tasks-list-item-left task-${taskStatu(task).className}`}>
            {task.ticketStatus.name}
        </div>
        <div className="tasks-list-item-mid">
            <div className="task-header text-semi-bold">
                <span className='text-primary'>{task.code}</span>
                <span> {task.title}</span>
            </div>
            <div className="task-tags">
                <div className={`task-tags-item text-${criticalLevel(task).className}`}>{task.ticketPriority.name}</div>
                <div className="task-tags-item text-default">{task.ticketType.name}</div>
            </div>
        </div>
        <div className="tasks-list-item-right text-muted text-sm">
            {task.createdBy} tarafından {moment(task.createdAt).format('DD.MM.YYYY')} tarihinde oluşturuldu
        </div>
    </Link>
  )
}
Task.propTypes = {
	task: PropTypes.object,
}
export default Task